import request from '@/api/request'

const getLottery = (params) => {
    return request({
        url: '/api/v1/activity/app/lottery/myPrizes',
        method: 'POST',
        data: params,
        domain: 'activity-app'
    })
}
export default {
    getLottery
}
